<template>
  <div>
    <div v-if="refreshing">
      <div style="width:100%; min-height:30vh" class="primary-color text-center mb-4">
        <div style="min-height: 20vh">
          &nbsp;
        </div>

        <div class="spinner-grow white" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <mdb-container>
        <mdb-row>
          <mdb-col class="text-left" md="7">
            <mdb-card class="mb-4" style="min-height:30vh">
              <mdb-card-header>

              </mdb-card-header>
              <mdb-card-body class="text-center">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mb-4" style="min-height:30vh">
              <mdb-card-header>

              </mdb-card-header>
              <mdb-card-body class="text-center">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
          <mdb-col class="text-left" md="5">
            <mdb-card class="mb-4" style="min-height:30vh">
              <mdb-card-header>

              </mdb-card-header>
              <mdb-card-body class="text-center">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mb-4" style="min-height:30vh">
              <mdb-card-header>

              </mdb-card-header>
              <mdb-card-body class="text-center">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>

    <div :class="pageClass" v-if="!refreshing">
      <mdb-mask :class="maskClass" :overlay="overlay">
        <banner suppressHomeIcon v-if="groupInfo && !showPrivateGroupMessage" :group="groupInfo" :suppressQuestions="showAvatarModal"/>
        <mdb-card-body v-if="translationMode">
          <translate-section category="page" sub-category="groupHome"/>
        </mdb-card-body>
        <mdb-container>
          <div v-if="showPrivateGroupMessage" class="gp-has-header">
            <mdb-card class="text-left mt-5">
              <mdb-card-header class="color-primary text-white">
                <h5>Private Group</h5>
              </mdb-card-header>
              <mdb-card-body v-if="loggedIn">
                <p>You are trying to access a private group without the secret URL.</p>
                <p>If you are following a link from an inviation, be sure to include the full URL. Otherwise, ask
                  the group owner for the secret URL.</p>
              </mdb-card-body>
              <mdb-card-body v-if="!loggedIn">
                <p>You are trying to access a private group. You must be logged in to {{ settings.siteName }} to access
                  that
                  group.</p>
                <mdb-btn icon="key" @click="$router.push('/login')">Login</mdb-btn>
                <mdb-btn v-if="!settings.registerGoesToPublicLanding" icon="user-plus"
                         @click="$router.push('/register')">Register
                </mdb-btn>
                <mdb-btn v-if="settings.registerGoesToPublicLanding" icon="user-plus" @click="$router.push('/')">
                  Register
                </mdb-btn>
              </mdb-card-body>
            </mdb-card>
          </div>

          <mdb-card v-if="loggedIn && groupInfo && groupInfo.deleteAfter" class="mb-4">
            <mdb-card-header class="danger-color text-white">Important</mdb-card-header>
            <mdb-card-body>
              This group is scheduled to be removed from the system on {{ groupInfo.deleteAfter }} due to inactivity.
              <div v-if="groupInfo && groupInfo.role=='Admin'">
                <mdb-btn color="success" icon="exclamation" @click="saveFromDelete">Don't Delete My Group!</mdb-btn>
              </div>
              <div v-if="groupInfo && groupInfo.role!='Admin'">If you think this is an error, please let the group admin
                know
                immediately.
              </div>
            </mdb-card-body>
          </mdb-card>

          <mdb-card v-if="diagnosticMode" class="mb-4">
            <mdb-card-header>
              <h5>
                <mdb-icon fal icon="wrench"/>
                Diagnostic
              </h5>
            </mdb-card-header>
            <mdb-card-body>
              <mdb-btn icon="bolt" rounded size="sm" @click="sendDiagnostics">Send Diagnostics Now</mdb-btn>
            </mdb-card-body>
          </mdb-card>

          <top-alerts v-if="loggedIn"/>

          <mdb-card class="mb-2 text-left" v-if="showRequireSubscription">
            <mdb-card-header class="warning-color">
              <h4>
                <mdb-icon icon="hand"/>
                Note
              </h4>
            </mdb-card-header>
            <mdb-card-body>
              Membership in this group requires a valid subscription.
              <router-link :to="'/user/plan-shopper?minTier=' + groupInfo.groupTierLevel">See options.</router-link>
            </mdb-card-body>
          </mdb-card>

          <div v-if="loggedIn && groupInfo && (groupInfo.role=='Public' || groupInfo.ownerProxied) && !hideJoin"
               class="join-bar text-right mb-2">
            <mdb-popover :forceShow="joinTooltip" :options="{placement: 'top'}">
              <span slot="header">You're not a member until you join!</span>
              <mdb-btn id="join-button" slot="reference" waves @click="join">{{ joinText }}</mdb-btn>
            </mdb-popover>
          </div>
          <div v-if="groupInfo && !loggedIn && !showPrivateGroupMessage && !groupInfo.invitationOnly" class="join-bar text-right mb-2">
            <mdb-btn v-if="!settings.registerGoesToPublicLanding" icon="user-plus" @click="$router.push('/register')">
              Register
            </mdb-btn>
            <mdb-btn v-if="settings.registerGoesToPublicLanding" icon="user-plus" @click="$router.push('/')">Register
            </mdb-btn>
          </div>
          <div
            v-if="loggedIn && groupInfo && groupInfo.role!='Public' && groupInfo.membershipStatus == 'Active' && groupInfo.donationsEnabled "
            class="join-bar text-right mb-2">
            <mdb-btn id="donate-button"
                     waves icon="donate"
                     @click="$router.push(groupInfo.homeUrl + '/donate')">Donate
            </mdb-btn>

          </div>
          <div v-if="groupInfo">
            <div class="text-danger" v-if="groupInfo.membershipStatus == 'Suspended'">
              <i>Your membership is currently suspended. <span
                v-if="groupInfo.suspendedReason">({{ groupInfo.suspendedReason }})</span> Access to group functions is
                limited.</i>
            </div>
            <mdb-card class="mb-2 text-left" v-if="groupInfo.paymentDisabledMessage">
              <mdb-card-header class="danger-color text-white">
                <h3>Warning</h3>
              </mdb-card-header>

              <mdb-card-body>
                <i>Your group is currently suspended due to payment problems.</i> Please
                <router-link to="/user/billing">review your account</router-link>
                to fix this. Group suspension will be removed
                once a payment has been successfully processed.
              </mdb-card-body>
            </mdb-card>
            <div class="text-danger"
                 v-if="userDetails && groupInfo.billingRule == 'MEMBER_PAYS' && !groupInfo.freeGroup && userDetails.billingSuspension ">
              There is a problem with your current subscription. Please
              <router-link to="/user/billing">review your account</router-link>
              to fix this.
            </div>

            <div v-for="(section,i) in groupInfo.sections" v-if="section.location=='Top'" v-bind:key="i"
                 class="mb-4 text-left">

              <content-section v-if="section.type=='Content'" :group="groupInfo" :section="section"/>
              <activity-feed v-if="section.type=='Activity Feed'" :group="groupInfo" :maxRows="5"
                             :showLinks="groupInfo.role!='Public'"/>
              <slideshow-section v-if="section.type=='Slideshow'" :group="groupInfo" :section="section"/>
              <links-section v-if="section.type=='Page Links'" :group="groupInfo" :section="section"/>
              <file-folder-section v-if="section.type=='File Folder'" :group="groupInfo" :section="section"/>
              <image-section v-if="section.type=='Image'" :group="groupInfo" :section="section"/>
              <image-feed-section v-if="section.type=='Image Feed'" :group="groupInfo" :section="section"/>
              <rss-feed-section v-if="section.type=='RSS Feed'" :group="groupInfo" :section="section"/>
              <Timeline v-if="section.type=='Twitter Feed'" :id="section.data.twitterName" sourceType="profile"
                        :options="{ tweetLimit: section.data.tweetsToShow }"/>
              <facebook-feed-section v-if="section.type=='Facebook Feed'" :title="section.pageLinksTitle"
                                     :group="groupInfo" :section="section" :facebookPage="section.facebookPage"/>
              <discussion-section v-if="section.type=='Recent Discussion'" :group="groupInfo" :section="section"/>
              <review-section v-if="section.type=='Review'" :group="groupInfo" :section="section"/>
              <team-section v-if="section.type=='Team'" :group="groupInfo" :section="section"/>
              <event-section v-if="section.type=='Upcoming Events'" :group="groupInfo" :eventData="section.data"/>
            </div>

            <mdb-row>
              <mdb-col class="text-left" md="7">
                <div v-for="(section,i) in groupInfo.sections" v-if="section.location=='Left' " v-bind:key="i">
                  <content-section v-if="section.type=='Content'" :group="groupInfo" :section="section"/>
                  <activity-feed v-if="section.type=='Activity Feed'" :group="groupInfo" :maxRows="5"
                                 :showLinks="groupInfo.role!='Public'"/>
                  <slideshow-section v-if="section.type=='Slideshow'" :group="groupInfo" :section="section"/>
                  <links-section v-if="section.type=='Page Links'" :group="groupInfo" :section="section"/>
                  <file-folder-section v-if="section.type=='File Folder'" :group="groupInfo" :section="section"/>
                  <image-section v-if="section.type=='Image'" :group="groupInfo" :section="section"/>
                  <image-feed-section v-if="section.type=='Image Feed'" :group="groupInfo" :section="section"/>
                  <rss-feed-section v-if="section.type=='RSS Feed'" :group="groupInfo" :section="section"/>
                  <Timeline v-if="section.type=='Twitter Feed'" :id="section.data.twitterName" sourceType="profile"
                            :options="{ tweetLimit: section.data.tweetsToShow }"/>
                  <facebook-feed-section v-if="section.type=='Facebook Feed'" :title="section.pageLinksTitle"
                                         :group="groupInfo" :section="section" :facebookPage="section.facebookPage"/>
                  <discussion-section v-if="section.type=='Recent Discussion'" :group="groupInfo"
                                      :section="section"/>
                  <review-section v-if="section.type=='Review'" :group="groupInfo" :section="section"/>
                  <team-section v-if="section.type=='Team'" :group="groupInfo" :section="section"/>
                  <event-section v-if="section.type == 'Upcoming Events'" :group="groupInfo"
                                 :event-data="section.data"/>
                </div>
              </mdb-col>

              <mdb-col class="text-left" md="5">
                <mdb-card
                  v-if="groupInfo && groupInfo.brand && groupInfo.brand.groupName && groupInfo.role != 'Public' && groupInfo.currentMember"
                  class="mb-2 text-primary">
                  <mdb-card-body class="text-info">
                    <mdb-icon icon="lightbulb"/>
                    As a member of the {{ groupInfo.brand.name }} family, be sure to check out
                    <router-link :to="groupInfo.brand.vanityPath">{{ groupInfo.brand.groupName }}</router-link>
                    for online events!
                  </mdb-card-body>
                </mdb-card>

                <mdb-card v-if="groupInfo && groupInfo.name && !groupInfo.isPrivate" class="mb-2">
                  <mdb-card-header>
                    Share On Social Media
                  </mdb-card-header>

                  <mdb-card-body class="text-primary">
                    <social-sharing :description="groupInfo.summary"
                                    :quote="groupInfo.summary"
                                    :title="groupInfo.name"
                                    :url="groupInfo.socialUrl"
                                    inline-template>
                      <div class="text-lg-center">
                        <network network="facebook" style="cursor:pointer;">
                          <i class="fab fa-facebook"></i> Facebook
                        </network>
                        <network network="twitter" style="cursor:pointer;">
                          <i class="fab fa-x-twitter"></i> Twitter
                        </network>
                        <network network="linkedin" style="cursor:pointer;">
                          <i class="fab fa-linkedin"></i> LinkedIn
                        </network>
                        <network network="email" style="cursor:pointer;">
                          <i class="fa fa-envelope"></i> Email
                        </network>
                      </div>
                    </social-sharing>
                  </mdb-card-body>
                </mdb-card>

                <div v-for="(section,i) in groupInfo.sections" v-if="section.location=='Right'" v-bind:key="i">

                  <content-section v-if="section.type=='Content'" :group="groupInfo" :section="section"/>
                  <activity-feed v-if="section.type=='Activity Feed'" :group="groupInfo" :maxRows="5"
                                 :showLinks="groupInfo.role!='Public'"/>
                  <slideshow-section v-if="section.type=='Slideshow'" :group="groupInfo" :section="section"/>
                  <links-section v-if="section.type=='Page Links'" :group="groupInfo" :section="section"/>
                  <file-folder-section v-if="section.type=='File Folder'" :group="groupInfo" :section="section"/>
                  <image-section v-if="section.type=='Image'" :group="groupInfo" :section="section"/>
                  <image-feed-section v-if="section.type=='Image Feed'" :group="groupInfo" :section="section"/>
                  <rss-feed-section v-if="section.type=='RSS Feed'" :group="groupInfo" :section="section"/>
                  <facebook-feed-section v-if="section.type=='Facebook Feed'" :title="section.pageLinksTitle"
                                         :group="groupInfo" :section="section" :facebookPage="section.facebookPage"/>
                  <Timeline v-if="section.type=='Twitter Feed'" :id="section.data.twitterName" sourceType="profile"
                            :options="{ tweetLimit: section.data.tweetsToShow }"/>
                  <discussion-section v-if="section.type=='Recent Discussion'" :group="groupInfo"
                                      :section="section"/>
                  <review-section v-if="section.type=='Review'" :group="groupInfo" :section="section"/>
                  <team-section v-if="section.type=='Team'" :group="groupInfo" :section="section"/>
                  <event-section v-if="section.type=='Upcoming Events'" :group="groupInfo" :eventData="section.data"/>
                </div>
              </mdb-col>
            </mdb-row>
          </div>

          <mdb-modal :show="showAvatarModal" class="animated"
                     info position="top-left"
                     removeBackdrop
                     v-if="groupInfo"
                     side @close="showAvatarModal = false">
            <mdb-modal-header>
              <p class="heading">Need a Profile Picture</p>
            </mdb-modal-header>
            <mdb-modal-body>
              <p class="text-left">{{ groupInfo.name }} requires that you have a profile picture associated with your
                profile
                before you may participate in the group.
              </p>
              <mdb-file-input v-on:getValue="uploadFile"/>

            </mdb-modal-body>
          </mdb-modal>

          <mdb-modal :show="showPendingModal" class="animated" info position="top-left"
                     removeBackdrop
                     v-if="groupInfo"
                     side @close="showPendingModal = false">
            <mdb-modal-header>
              <p class="heading">Request Pending</p>
            </mdb-modal-header>
            <mdb-modal-body>
              <p class="text-left">Your request to join {{ groupInfo.name }} has been submitted, but is pending
                approval.
              </p>
              <mdb-btn v-if="!cancelPending" @click="cancelPending=true" size="sm" rounded color="warning">Remove Join
                Request
              </mdb-btn>
              <div v-if="cancelPending">
                <div>Are you sure?</div>
                <mdb-btn @click="cancelJoin" size="sm" color="danger" rounded>Yes, Cancel Request</mdb-btn>
                <mdb-btn @click="cancelPending=false" size="sm" color="success" rounded>No</mdb-btn>

              </div>
            </mdb-modal-body>
          </mdb-modal>

          <mdb-modal v-if="showQuestions" size="lg"
                     :removeBackdrop="true" scrollable
                     @close="showQuestions = false">
            <mdb-modal-header :close="false" center class="primary-color text-white">
              <h4>Questions from {{ groupInfo.name }}</h4>
            </mdb-modal-header>
            <mdb-modal-body>
              <answers :group="groupInfo" :show-all="false" @submit="answered"/>
            </mdb-modal-body>
          </mdb-modal>
        </mdb-container>
      </mdb-mask>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import api from '../../services/groupsPlaceApi.js'
import topAlerts from "../common/TopAlerts";
import TopAlerts from "../common/TopAlerts";
import {Timeline} from 'vue-tweet-embed';
import {
  mdbAlert,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbFileInput,
  mdbIcon,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbNavbar,
  mdbPopover,
  mdbRow,
  mdbView
} from 'mdbvue';
import ContentSection from '../homeSections/Content'
import SlideshowSection from '../homeSections/SlideShow'
import LinksSection from '../homeSections/Links'
import ActivityFeed from "../ActivityFeed";
import Banner from './Banner'
import BannerSmall from "./BannerSmall";
import ImageSection from '../homeSections/Image'
import ImageFeedSection from '../homeSections/ImageFeed'
import RssFeedSection from "../homeSections/RssFeed";
import FacebookFeedSection from "../homeSections/FacebookFeed";
import DiscussionSection from '../homeSections/RecentDiscussion'
import ReviewSection from '../homeSections/Review'
import FileFolderSection from "../homeSections/FileFolder";
import TeamSection from '../homeSections/Team'
import EventSection from '../homeSections/UpcomingEvents'
import Answers from './Answers'
import Error from '../common/Error'
import Vue from "vue";
import translateModal from "../common/TranslateModal";
import translateSection from "../common/TranslateSection";

export default {
  name: 'Home',
  components: {
    TopAlerts,
    ContentSection,
    ActivityFeed,
    LinksSection,
    SlideshowSection,
    ImageSection,
    ImageFeedSection,
    DiscussionSection,
    ReviewSection,
    TeamSection,
    FileFolderSection,
    RssFeedSection,
    FacebookFeedSection,
    EventSection,
    Banner,
    BannerSmall,
    Timeline,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbDropdown,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbNavbar,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbBtn,
    mdbView,
    mdbMask,
    mdbCardGroup,
    mdbIcon,
    mdbAlert,
    mdbPopover,
    mdbFileInput,
    Error,
    Answers,
    topAlerts,
    translateSection,
    translateModal
  },
  computed: mapState({
                       apiKey: state => state.apiKey,
                       secret: state => state.secret,
                       userDetails: state => state.userDetails,
                       loggedIn: state => state.loggedIn,
                       diagnosticMode: state => state.diagnosticMode,
                       settings: state => state.settings,
                       translationMode: state => state.translationMode
                     }),
  data() {
    return {
      groupInfo: null,
      refreshing: true,
      unauthorizedMessage: null,
      errorMessage: null,
      error: null,
      joinText: "Join Now",
      showAvatarModal: false,
      showRequireSubscription: false,
      hideJoin: false,
      joinTooltip: false,
      answers: [],
      showQuestions: false,
      showPendingModal: false,
      showPrivateGroupMessage: false,
      pageClass: "",
      maskClass: "",
      overlay: "",
      paymentData: null,
      planInfo: null,
      cancelPending: false,
      jiggles: 0
    };
  },
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: this.getHomeLink(),
        }
      ]
    }
  },
  async mounted() {
    await this.loadPage()
    window.scrollTo(0, 0)
  },
  watch: {
    userDetails: function (a, b) {
      if (b && b.name == "Guest" && a.name != "Guest") this.checkAvatar()
    },
    groupInfo: function (a, b) {
      this.checkAvatar()
    }
  },
  methods: {
    cancelJoin: function () {
      this.showPendingModal = false
      this.$store.dispatch("setExecuting", true);
      api.post("/member/cancelJoin/" + this.groupInfo.vanityPath, {}).then(
        (results) => {
          this.$notify.success({message: "Join request removed.", timeOut: 10000})
          this.$router.push("/")
        },
        (error) => {
          this.showPendingModal = true
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    getHomeLink: function () {
      if (this.groupInfo) {
        return this.groupInfo.socialUrl
      } else return this.settings.staticSiteUrl
    },
    uploadFile: async function (file) {
      this.showAvatarModal = false
      this.$store.dispatch("setExecuting", true)

      let uploadRequest
      await api.post("/user/getImageUploadUrl", {filename: file[0].name,
        size: file[0].size,
        contentType: file[0].type}).then(
        (results) => {
          uploadRequest = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
          this.$store.dispatch("setExecuting", false)
        }
      )

      if (!uploadRequest) return

      const response = await fetch(uploadRequest.url, {
        method: 'PUT',
        body: file[0],
        headers: {
          'Content-Type': file[0].type
        },
      })

      if (!response.ok) {
        const errorText = await response.text()
        this.$notify.error({message: errorText, timeOut: 5000})
        this.$store.dispatch("setExecuting", false)
        return

      }

      api.post("/user/uploadAvatar", uploadRequest).then(
        (results2) => {
          this.$notify.success({message: "Image uploaded successfully.", timeOut: 3000})
          this.userDetails.hasAvatar = true
          this.join()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    sendDiagnostics() {
      this.$store.dispatch("setExecuting", true);
      let payload = {
        group: this.groupInfo,
        path: this.$route.fullPath,
        answers: this.answers,
        error: this.error
      }
      api.post("/user/diagnostics", payload).then(
        (results) => {
          this.$notify.success({message: "Diagnostic Report Sent. Thank you!", timeOut: 10000})
        },
        (error) => {
          console.error(error.response);
          this.$notify.error({message: error.response, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    checkAvatar: function () {
      if (this.userDetails && this.userDetails.name == "Guest") return
      if (!this.groupInfo) return
      if (this.groupInfo.role != "Public" && !this.userDetails.hasAvatar && this.groupInfo.requirePhoto) {
        this.showAvatarModal = true
      }
    },
    loadPage: async function () {
      this.refreshing = true
      this.groupInfo = {}
      let url = "/group/home/" + this.$route.params.id
      if (this.$route.query.secret) url += "?secret=" + this.$route.query.secret
      if (this.$route.query.viewAs) url += "?viewAs=" + this.$route.query.viewAs
      api.get(url, {}).then(
        (response) => {
          this.groupInfo = response.data
          if (this.groupInfo.showChecklist) {
            this.$router.push("/group/setup/" + this.$route.params.id)
            return
          }

          if (this.groupInfo.requireApproval) this.joinText = "Ask to Join"
          if (this.groupInfo.membershipPending) {
            this.hideJoin = true
            this.showPendingModal = true
          }
          if (this.userDetails.billingSuspension) {
            if (this.groupInfo.billingRule == "MEMBER_PAYS" && !this.groupInfo.freeGroup) {
              this.hideJoin = true
            }
          }
          if (this.userDetails && this.groupInfo.billingRule == "MEMBER_PAYS" &&
            this.groupInfo.role == 'Public' && this.groupInfo.groupTierLevel > this.userDetails.subscriptionTierLevel) {
            this.hideJoin = true
            this.showRequireSubscription = true
          }
          if (this.groupInfo.invitationOnly) {
            this.hideJoin = true
          }
          document.title = this.groupInfo.name
          if (this.groupInfo.background) this.setBackground()
          this.checkAvatar()
          if (this.$route.query.doJoin == "Y") {
            this.join()
          } else {
            Vue.nextTick().then(() => {
              let joinBtn = document.getElementById("join-button")
              if (joinBtn) {
                setTimeout(() => {
                  this.jiggleJoin(joinBtn)
                }, 2000)
              }
            })
          }
          this.refreshing = false;
          this.$store.dispatch("setCurrentGroup", this.groupInfo)

        },
        (error) => {
          this.refreshing = false
          this.error = error
          if (!error || !error.response) {
            this.$notify.error({
                                 message: "Network connection problem. Please try refreshing the page." + error.response.data,
                                 timeOut: 5000
                               })
          }
          if (error.response.status == 400) {
            //we could have flipped into maint mode; reload app
            window.location = "/"
          }
          if (error.response.status == 403) {
            this.showPrivateGroupMessage = true
          }
          if (error.response.status == 404) {
            this.$router.push("/notFound")
          }
          if (error.response.status == 306) {
            window.location = error.response.data.url
          }
        }
      );

    },
    jiggleJoin: function (btn) {
      this.jiggles++
      if (this.jiggles > 10) {
        btn.classList.remove("btn-warning")
        btn.classList.add("btn-default")
        this.joinTooltip = false
        return
      }
      if (btn.classList.contains("btn-default")) {
        btn.classList.remove("btn-default")
        btn.classList.add("btn-warning")
      } else if (btn.classList.contains("btn-warning")) {
        btn.classList.remove("btn-warning")
        btn.classList.add("btn-default")
      }
      this.joinTooltip = true
      setTimeout(() => this.jiggleJoin(btn), 1000)
    },
    setBackground: function () {
      this.pageClass = "full-view"
      this.maskClass = "overflow-auto gp-full-overlay"
      this.overlay = "stylish-strong"
      Vue.nextTick().then(() => {
        let el = document.getElementsByClassName("full-view")
        if (el) {
          el[0].setAttribute("style", "background-image: url('" + this.groupInfo.background + "');")
        }
      })
    },
    answered(answers) {
      this.answers = answers
      this.showQuestions = false
      this.submitJoin()
    },
    refresh: function () {
      this.loadPage()
    },
    join: function () {
      this.hideJoin = true
      if (this.groupInfo.requirePhoto && !this.userDetails.hasAvatar) {
        this.showAvatarModal = true
        this.hideJoin = false
        return
      }
      if (this.groupInfo.questions > 0 && this.answers.length < this.groupInfo.questions && !this.groupInfo.ownerProxied) {
        this.showQuestions = true
        this.hideJoin = false
        return
      }
      this.submitJoin()
    },
    submitJoin() {
      this.hideJoin = true
      let payload = {secret: null, answers: this.answers}
      if (this.$route.query.secret) payload.secret = this.$route.query.secret
      api.post("/member/join/" + this.groupInfo.vanityPath, payload).then(
        (details) => {
          if (this.$route.query.doJoin == "Y") {
            window.location = "/group/" + this.groupInfo.vanityPath
          } else location.reload()
        },
        (error) => {
          if (error.response.status == 402) {
            let qs = encodeURI("?source=paywall-join&group=" + this.groupInfo.name + "&return=" + this.groupInfo.homeUrl)
            this.$router.push("/user/billing" + qs)
          } else this.$notify.error({message: "Could not join at this time." + error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    saveFromDelete() {
      this.$store.dispatch("setExecuting", false)
      api.post("/group/saveFromDelete/" + this.groupInfo.vanityPath, {}).then(
        (details) => {
          this.groupInfo.deleteAfter = null
          this.$notify.success({
                                 message: "Your group has been removed from the delete list. To prevent this from happening again, be sure to visit your group at least once every 90 days.",
                                 timeOut: 8000
                               })
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toProfile: function () {
      this.$router.push("/user/profile")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
